import axiosInstance from '../config/axios.js';

const API_BASE = '/onhires';

const onhireService = {
  // Get all onhires with optional filters and pagination
  getAll: async (page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { page, per_page: perPage, ...params }
      : { all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all onhires without pagination
  getAllOnhires: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get client published onhires (for clients)
  getClientOnhires: async (clientId, page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      client_id: clientId,
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/client`, { params: queryParams });
    return response.data;
  },

  // Get onhire by ID
  getById: async (onhireId) => {
    const response = await axiosInstance.get(`${API_BASE}/${onhireId}`, {
      params: { include_images: 'true' }
    });
    return response.data;
  },

  // Get image 1 URL
  getImage1: (onhireId) => {
    return `${axiosInstance.defaults.baseURL}${API_BASE}/${onhireId}/image1`;
  },

  // Get image 2 URL
  getImage2: (onhireId) => {
    return `${axiosInstance.defaults.baseURL}${API_BASE}/${onhireId}/image2`;
  },

  // Create new onhire
  create: async (onhireData) => {
    const response = await axiosInstance.post(API_BASE, onhireData);
    return response.data;
  },

  // Update onhire
  update: async (onhireId, onhireData) => {
    const response = await axiosInstance.put(`${API_BASE}/${onhireId}`, onhireData);
    return response.data;
  },

  // Toggle published status
  togglePublished: async (onhireId) => {
    const response = await axiosInstance.patch(`${API_BASE}/${onhireId}/toggle-published`);
    return response.data;
  },

  // Delete onhire
  delete: async (onhireId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${onhireId}`);
    return response.data;
  },

  // Toggle send_to_dm status
  toggleSendToDM: async (onhireId) => {
    const response = await axiosInstance.patch(`${API_BASE}/${onhireId}/toggle-send-to-dm`);
    return response.data;
  },

  // Get pending onhires for DM
  getPendingForDM: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/pending-for-dm`, { params: queryParams });
    return response.data;
  },

  // Download onhire report
  downloadReport: async (id) => {
    const response = await axiosInstance.get(
      `${API_BASE}/${id}/report/download`,
      { responseType: 'blob' }
    );
    return response.data;
  },

  // Send bulk email for selected onhires
  sendBulkEmail: async (onhireIds) => {
    const response = await axiosInstance.post(`${API_BASE}/send-bulk-email`, {
      ids: onhireIds
    });
    return response.data;
  },

  // Download bulk PDFs for selected onhires (single PDF or ZIP)
  downloadBulkPDF: async (onhireIds) => {
    const response = await axiosInstance.post(`${API_BASE}/bulk-pdf-download`, {
      ids: onhireIds
    }, {
      responseType: 'blob'
    });
    return response;
  },

  // Export CSV for selected onhires
  exportCSV: async (onhireIds) => {
    const response = await axiosInstance.post(`${API_BASE}/export-csv`, {
      ids: onhireIds
    }, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Duplicate an onhire record
  duplicate: async (onhireId) => {
    const response = await axiosInstance.post(`${API_BASE}/${onhireId}/duplicate`);
    return response.data;
  },
};

export default onhireService;